"use client";

import PlusCircleIcon from "@heroicons/react/24/outline/PlusCircleIcon";
import ContactCard from "@/components/views/about/contact/ContactCard";
import { useSite } from "@/lib/hooks/site";
import { useState } from "react";
import { ROUTES } from "@/@core/constants/routes";
import { ContactCardProps } from "@/components/views/about/types";
import dynamic from "next/dynamic";
import { MANAGER_URL } from "@/lib/constants";
import { useTranslation } from "@/hooks/translationContext";

interface Params {
  contactTitle: string;
  contactDescription: string;
}

const CreateProfile = dynamic(
  () => import("../../modals/create-profile/index"),
);

export default function ContactPage(params: Params) {
  const { t } = useTranslation();
  const { contactTitle = t("contact-page-title"), contactDescription = "" } = params;
  const { domain } = useSite();
  const [show, setShow] = useState(false);

  const contactCards = [
    {
      title: t("contact-page-business-partner-title", {
        defaultValue: "İş Ortağıyım",
      }),
      text: t("contact-page-business-partner-description", {
        defaultValue: `${domain} mekanınız varsa yönetmeye hemen başlayabilirsin! Yoksa işletmenizi ekleyebilirsiniz.`,
      }),
      background: "background white",
      buttons: [
        {
          label: (
            <>
              {t("venue-add-title", {
                defaultValue: "Mekan Ekle",
              })}
              <PlusCircleIcon className="size-5" />
            </>
          ),
          variant: "accent",
          href: ROUTES.VENUE.CREATE,
        },
        {
          label: t("contact-page-venue-owner-button"),
          variant: "white",
          href: MANAGER_URL,
        },
      ],
    },
    {
      title: t("contact-page-worker-profile-title", {
        defaultValue: "Spor Öğretmeniyim",
      }),
      text: t("contact-page-worker-profile-description", {
        defaultValue: `${domain} adresinde kayıtlı bir mekanda eğitmen misiniz? Kayıt olabilir sonrasında hızlıca profil oluşturabilrisiniz`,
      }),
      buttons: [
        {
          label: (
            <>
              Kayıt Ol <PlusCircleIcon className="size-5" />
            </>
          ),
          variant: "primary-dark",
        },
        {
          label: t("contact-page-worker-profile-button"),
          variant: "white",
          onclick: () => {
            setShow(true);
          },
        },
      ],
      background: "background white",
    },
    {
      title: contactTitle,
      text: <p dangerouslySetInnerHTML={{ __html: contactDescription }} />,
      background: "rounded-3xl bg-gray",
      buttons: [
        {
          label: (
            <>
              İletişim Formu <PlusCircleIcon className="size-5" />
            </>
          ),
          variant: "gradient",
          href: ROUTES.ABOUT.CONTACT,
        },
      ],
    },
  ] as ContactCardProps[];

  return (
    <div className="text-primary font-medium font-sans mt-4">
      {show && <CreateProfile isOpen={show} onClose={() => setShow(false)} />}

      <div className="flex flex-wrap max-md:flex-col gap-6 justify-center">
        {contactCards.map((card: ContactCardProps, index) => (
          <ContactCard key={index} {...card} />
        ))}
      </div>
    </div>
  );
}
